/* import __COLOCATED_TEMPLATE__ from './oauth-banner.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';
import type IntlService from 'embercom/services/intl';

const HIDE_IN_ROUTES = [
  'apps.app.loading',
  'apps.app.copilot-frame',
  'apps.app.settings.standalone.integration',
  'apps.app.standalone.deploy.zendesk.tickets.integrate',
  'apps.app.standalone.deploy.zendesk.messaging.integrate',
  'apps.app.standalone.deploy.intercom-messenger.integrate',
];

export interface Signature {
  Args: {
    onClick?: () => void;
    showInline?: boolean;
  };
  Blocks: {};
  Element: null;
}

export default class StandaloneZendeskOauthBanner extends Component<Signature> {
  @service declare appService: {
    mainStandalonePlatform: {
      showOauthBanner: boolean;
      showApiKeyFallbackBanner: boolean;
    };
    app: $TSFixMe;
  };
  @service declare router: RouterService;
  @service declare intl: IntlService;

  get app() {
    return this.appService.app;
  }

  get standalonePlatform() {
    return this.appService.mainStandalonePlatform;
  }

  get isApiKeyFallbackBanner(): boolean {
    return this.standalonePlatform.showApiKeyFallbackBanner;
  }

  get shouldShowBanner(): boolean {
    if (!this.args.showInline && HIDE_IN_ROUTES.includes(this.router.currentRouteName)) {
      return false;
    }

    return (
      this.standalonePlatform.showOauthBanner || this.standalonePlatform.showApiKeyFallbackBanner
    );
  }

  get messageText(): string {
    if (this.isApiKeyFallbackBanner) {
      return this.args.showInline
        ? this.intl.t('standalone.zendesk.api-key-fallback-banner.message-inline')
        : this.intl.t('standalone.zendesk.api-key-fallback-banner.message');
    }
    return this.args.showInline
      ? this.intl.t('standalone.zendesk.oauth-banner.message-inline')
      : this.intl.t('standalone.zendesk.oauth-banner.message');
  }

  get buttonLabel(): string {
    if (this.isApiKeyFallbackBanner) {
      return this.intl.t('standalone.zendesk.api-key-fallback-banner.button-label');
    }
    return this.intl.t('standalone.zendesk.oauth-banner.button-label');
  }

  @action
  buttonClick() {
    if (this.args.onClick) {
      this.args.onClick();
    } else {
      this.router.transitionTo('apps.app.settings.standalone.integration');
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Zendesk::OauthBanner': typeof StandaloneZendeskOauthBanner;
    'standalone/zendesk/oauth-banner': typeof StandaloneZendeskOauthBanner;
  }
}
